import { render } from "./LivingRecord.vue?vue&type=template&id=6c174bf0&scoped=true"
import script from "./LivingRecord.vue?vue&type=script&lang=js"
export * from "./LivingRecord.vue?vue&type=script&lang=js"

import "./LivingRecord.vue?vue&type=style&index=0&id=6c174bf0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6c174bf0"

export default script